import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllattendanceReport = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/attendance');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Attendance Report');
        }
    }
);

export const fetchAllattendanceReportcount = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/attendance/count/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Attendance Report');
        }
    }
);

export const fetchAllattendanceReportDetails = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/attendance/details/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Attendance Report');
        }
    }
);
export const fetchEmployeeTime = createAsyncThunk(
    'report/fetchemployeeTime',
    async ({employeeId , date}: any, { rejectWithValue }) => {
        console.log(employeeId ,date);
        try {
            const response = await employeeServiceApiInstance.get(`/report/attendance/employeetime?employeeId=${employeeId}&date=${date}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Employee Report');
        }
    }
);



